module.exports = __webpack_public_path__ + "static/linkedin-logo-0deafe2c4674bf7bfab70e801b588699.webm";